// styles
import "../styles/Home.css";

// components
import Hero from "../components/Home/Hero";
import Coaches from "../components/Home/Coaches";
import Categories from "../components/Home/Categories";
import RecommendedRecipes from "../components/Home/RecommendedRecipes";
import Newsletter from "../components/Newsletter";
import HomeAd from "../components/Home/HomeAd";

const Home = () => {
  return (
    <div>
      <Hero />
      <Coaches />
      <Categories />
      <RecommendedRecipes />
      {/* <HomeAd /> */}
      <Newsletter />
    </div>
  );
};

export default Home;
